import React from "react";

// Thumb
import bigWomenClothing from "../../images/category-thumb-big-women-clothing.jpg";
import jewelryAccessories from "../../images/category-thumb-jewelry-accessories.jpg";
import techAccessories from "../../images/category-thumb-tech-accessories.jpg";
import kidsAndBabies from "../../images/category-thumb-kids-babies.jpg";
import toys from "../../images/category-thumb-toys.png";
import footwear from "../../images/category-thumb-footwear.jpg";
import bathBeauty from "../../images/category-thumb-bath-beauty.jpg";
import pets from "../../images/category-thumb-pets.jpg";
import homeGarden from "../../images/category-thumb-home-garden.jpg";
import accessories from "../../images/category-thumb-accessories.jpg";

// Icon
import iconJewelWatch from "../../images/icons-jewel-watch.svg";
import iconBathBeauty from "../../images/icons-bath-beauty.svg";
import iconToys from "../../images/icon-toys.svg";
import iconPets from "../../images/icons-pets.svg";
import iconAccessories from "../../images/icon-accessories.svg";
import iconKidBabies from "../../images/icons-kid-babies.svg";
import iconFootwear from "../../images/icons-footwear.svg";
import iconMenClothing from "../../images/icons-men-clothing.svg";
import iconWomenClothing from "../../images/icons-women-clothing.svg";
import iconSportOutdoor from "../../images/icons-sport-outdoor.svg";
import iconTechAccessories from "../../images/icons-tech-accessories.svg";
import iconGift from "../../images/icons-gift.svg";
import iconHomeGarden from "../../images/icons-home-garden.svg";
import iconAutomotive from "../../images/icon-automotive.svg";
import iconBagWallet from "../../images/icon-bag-wallet.svg";
import iconFestivalsParties from "../../images/icon-festivals-parties.svg";
import iconSeasonal from "../../images/icon-seasonal.svg";

import i18n from '../../../i18n';

export const mainCategories = () => [
  {
    name: "Women's Clothing",
    label: i18n.t("StaticCategories.WomensClothing"),
    icon: <img src={bigWomenClothing} alt="Category" />
  },
  {
    name: "Jewelry & Watches",
    label: i18n.t("StaticCategories.JewelryWatches"),
    icon: <img src={jewelryAccessories} alt="Category" />
  },
  {
    name: "Tech Accessories",
    label: i18n.t("StaticCategories.TechAccessories"),
    icon: <img src={techAccessories} alt="Category" />
  },
  {
    name: "Kids & Babies",
    label: i18n.t("StaticCategories.KidsBabies"),
    icon: <img src={kidsAndBabies} alt="Category" />
  },
  {
    name: "Toys",
    label: i18n.t("StaticCategories.Toys"),
    icon: <img src={toys} alt="Category" />
  },
  {
    name: "Footwear",
    label: i18n.t("StaticCategories.Footwear"),
    icon: <img src={footwear} alt="Category" />
  },
  {
    name: "Bath & Beauty",
    label: i18n.t("StaticCategories.BathBeauty"),
    icon: <img src={bathBeauty} alt="Category" />
  },
  {
    name: "Pets",
    label: i18n.t("StaticCategories.Pets"),
    icon: <img src={pets} alt="Category" />
  },
  {
    name: "Home & Garden",
    label: i18n.t("StaticCategories.HomeGarden"),
    icon: <img src={homeGarden} alt="Category" />
  },
  {
    name: "Accessories",
    label: i18n.t("StaticCategories.Accessories"),
    icon: <img src={accessories} alt="Category" />
  }
];

export const highlightCategory = mainCategories()[0];

export const moreCategories = () => [
  {
    name: "Men's Clothing",
    label: i18n.t("StaticCategories.MensClothing"),
    icon: <img src={iconMenClothing} alt="Category" />
  },
  {
    name: "Tech Accessories",
    label: i18n.t("StaticCategories.TechAccessories"),
    icon: <img src={iconTechAccessories} alt="Category" />
  },
  {
    name: "Sports & Outdoors",
    label: i18n.t("StaticCategories.SportsOutdoors"),
    icon: <img src={iconSportOutdoor} alt="Category" />
  },
  {
    name: "Gifts",
    label: i18n.t("StaticCategories.Gifts"),
    icon: <img src={iconGift} alt="Category" />
  },
  {
    name: "Automotive",
    label: i18n.t("StaticCategories.Automotive"),
    icon: <img src={iconAutomotive} alt="Category" />
  },
  {
    name: "Bags & Wallets",
    label: i18n.t("StaticCategories.BagsWallets"),
    icon: <img src={iconBagWallet} alt="Category" />
  },
  {
    name: "Seasonal",
    label: i18n.t("StaticCategories.Seasonal"),
    icon: <img src={iconSeasonal} alt="Category" />
  },
  {
    name: "Festivals & Parties",
    label: i18n.t("StaticCategories.FestivalsParties"),
    icon: <img src={iconFestivalsParties} alt="Category" />
  }
];

export const allCategories = () => [
  {
    value: "Women's Clothing",
    label: i18n.t("StaticCategories.WomensClothing"),
    icon: <img src={iconWomenClothing} alt="Category" />,
    subcategories: [
      { name: "Activewear", label: i18n.t("StaticCategories.WomensClothing.Activewear") },
      { name: "Bodysuits", label: i18n.t("StaticCategories.WomensClothing.Bodysuits") },
      { name: "Dresses", label: i18n.t("StaticCategories.WomensClothing.Dresses") },
      { name: "Jackets & Coats", label: i18n.t("StaticCategories.WomensClothing.JacketsCoats") },
      { name: "Jeans", label: i18n.t("StaticCategories.WomensClothing.Jeans") },
      { name: "Jumpsuits & Rompers", label: i18n.t("StaticCategories.WomensClothing.JumpsuitsRompers") },
      { name: "Leggings", label: i18n.t("StaticCategories.WomensClothing.Leggings") },
      { name: "Lingerie & Underwear", label: i18n.t("StaticCategories.WomensClothing.LingerieUnderwear") },
      { name: "Matching Sets", label: i18n.t("StaticCategories.WomensClothing.MatchingSets") },
      { name: "Pants", label: i18n.t("StaticCategories.WomensClothing.Pants") },
      { name: "Shorts", label: i18n.t("StaticCategories.WomensClothing.Shorts") },
      { name: "Skirts", label: i18n.t("StaticCategories.WomensClothing.Skirts") },
      { name: "Sleepwear", label: i18n.t("StaticCategories.WomensClothing.Sleepwear") },
      { name: "Socks", label: i18n.t("StaticCategories.WomensClothing.Socks") },
      { name: "Sweaters & Hoodies", label: i18n.t("StaticCategories.WomensClothing.SweatersHoodies") },
      { name: "Swimwear", label: i18n.t("StaticCategories.WomensClothing.Swimwear") },
      { name: "Tank Tops", label: i18n.t("StaticCategories.WomensClothing.TankTops") },
      { name: "Tops & Blouses", label: i18n.t("StaticCategories.WomensClothing.TopsBlouses") },
      { name: "T-shirts", label: i18n.t("StaticCategories.WomensClothing.Tshirts" )}
    ]
  },
  {
    value: "Jewelry & Watches",
    label: i18n.t("StaticCategories.JewelryWatches"),
    icon: <img src={iconJewelWatch} alt="Category" />,
    subcategories: [
      { name: "Bracelets", label: i18n.t("StaticCategories.JewelryWatches.Bracelets") },
      { name: "Earrings", label: i18n.t("StaticCategories.JewelryWatches.Earrings") },
      { name: "Necklaces", label: i18n.t("StaticCategories.JewelryWatches.Necklaces") },
      { name: "Other Accessories", label: i18n.t("StaticCategories.JewelryWatches.OtherAccessories") },
      { name: "Pendants, Stones & Charms", label: i18n.t("StaticCategories.JewelryWatches.PendantsStonesCharms") },
      { name: "Rings", label: i18n.t("StaticCategories.JewelryWatches.Rings") },
      { name: "Sets", label: i18n.t("StaticCategories.JewelryWatches.Sets") },
      { name: "Watches", label: i18n.t("StaticCategories.JewelryWatches.Watches" )}
    ]
  },
  {
    value: "Bath & Beauty",
    label: i18n.t("StaticCategories.BathBeauty"),
    icon: <img src={iconBathBeauty} alt="Category" />,
    subcategories: [
      { name: "Bodycare", label: i18n.t("StaticCategories.BathBeauty.Bodycare") },
      { name: "Diffusers, Oils & Candles", label: i18n.t("StaticCategories.BathBeauty.DiffusersOilsCandles") },
      { name: "Haircare", label: i18n.t("StaticCategories.BathBeauty.Haircare") },
      { name: "Healthcare", label: i18n.t("StaticCategories.BathBeauty.Healthcare") },
      { name: "Makeup", label: i18n.t("StaticCategories.BathBeauty.Makeup") },
      { name: "Nails", label: i18n.t("StaticCategories.BathBeauty.Nails") },
      { name: "Skincare", label: i18n.t("StaticCategories.BathBeauty.Skincare") },
      { name: "Towels & Robes", label: i18n.t("StaticCategories.BathBeauty.TowelsRobes")}
    ]
  },
  {
    value: "Tech Accessories",
    label: i18n.t("StaticCategories.TechAccessories"),
    icon: <img src={iconTechAccessories} alt="Category" />,
    subcategories: [
      { name: "Audio & Video", label: i18n.t("StaticCategories.TechAccessories.AudioVideo") },
      { name: "Cases & Covers", label: i18n.t("StaticCategories.TechAccessories.CasesCovers") },
      { name: "Lighting", label: i18n.t("StaticCategories.TechAccessories.Lighting") },
      { name: "Mobile & Laptop Accessories", label: i18n.t("StaticCategories.TechAccessories.MobileLaptopAccessories") },
      { name: "Mousepads", label: i18n.t("StaticCategories.TechAccessories.Mousepads") },
      { name: "Novelty", label: i18n.t("StaticCategories.TechAccessories.Novelty") }
    ]
  },
  {
    value: "Pets",
    label: i18n.t("StaticCategories.Pets"),
    icon: <img src={iconPets} alt="Category" />,
    subcategories: [
      { name: "Beds & Blankets", label: i18n.t("StaticCategories.Pets.BedsBlankets") },
      { name: "Leashes, Collars & Petwear", label: i18n.t("StaticCategories.Pets.LeashesCollarsPetwear") },
      { name: "Petcare", label: i18n.t("StaticCategories.Pets.Petcare") },
      { name: "Toys", label: i18n.t("StaticCategories.Pets.Toys") },
    ]
  },
  {
    value: "Kids & Babies",
    label: i18n.t("StaticCategories.KidsBabies"),
    icon: <img src={iconKidBabies} alt="Category" />,
    subcategories: [
      { name: "Baby Clothing", label: i18n.t("StaticCategories.KidsBabies.BabyClothing") },
      { name: "Bathing", label: i18n.t("StaticCategories.KidsBabies.Bathing") },
      { name: "Blankets & Pillows", label: i18n.t("StaticCategories.KidsBabies.BlanketsPillows") },
      { name: "Caps & Headbands", label: i18n.t("StaticCategories.KidsBabies.CapsHeadbands") },
      { name: "Footwear", label: i18n.t("StaticCategories.KidsBabies.Footwear") },
      { name: "Furniture", label: i18n.t("StaticCategories.KidsBabies.Furniture") },
      { name: "Kid's Clothing", label: i18n.t("StaticCategories.KidsBabies.KidsClothing") },
      { name: "Parenthood & Accessories", label: i18n.t("StaticCategories.KidsBabies.ParenthoodAccessories") },
    ]
  },
  {
    value: "Home & Garden",
    label: i18n.t("StaticCategories.HomeGarden"),
    icon: <img src={iconHomeGarden} alt="Category" />,
    subcategories: [
      { name: "Bathroom", label: i18n.t("StaticCategories.HomeGarden.Bathroom") },
      { name: "Clocks", label: i18n.t("StaticCategories.HomeGarden.Clocks") },
      { name: "Drinkware", label: i18n.t("StaticCategories.HomeGarden.Drinkware") },
      { name: "Food & Beverage", label: i18n.t("StaticCategories.HomeGarden.FoodBeverage") },
      { name: "Furniture", label: i18n.t("StaticCategories.HomeGarden.Furniture") },
      { name: "Garden", label: i18n.t("StaticCategories.HomeGarden.Garden") },
      { name: "Home Decor", label: i18n.t("StaticCategories.HomeGarden.HomeDecor") },
      { name: "Home Improvement", label: i18n.t("StaticCategories.HomeGarden.HomeImprovement") },
      { name: "Kitchen", label: i18n.t("StaticCategories.HomeGarden.Kitchen") },
      { name: "Lighting", label: i18n.t("StaticCategories.HomeGarden.Lighting") },
      { name: "Organization", label: i18n.t("StaticCategories.HomeGarden.Organization") },
      { name: "Stationery & Crafts", label: i18n.t("StaticCategories.HomeGarden.StationeryCrafts") },
      { name: "Textiles & Pillows", label: i18n.t("StaticCategories.HomeGarden.TextilesPillows") },
      { name: "Tools", label: i18n.t("StaticCategories.HomeGarden.Tools") },
    ]
  },
  { value: "Toys", label: i18n.t("StaticCategories.Toys"), icon: <img src={iconToys} alt="Category" /> },
  {
    value: "Accessories",
    label: i18n.t("StaticCategories.Accessories"),
    icon: <img src={iconAccessories} alt="Category" />,
    subcategories: [
      { name: "Belts", label: i18n.t("StaticCategories.Accessories.Belts") },
      { name: "Cufflinks", label: i18n.t("StaticCategories.Accessories.Cufflinks") },
      { name: "Hats", label: i18n.t("StaticCategories.Accessories.Hats") },
      { name: "Keychains", label: i18n.t("StaticCategories.Accessories.Keychains") },
      { name: "Scarves & Bandanas", label: i18n.t("StaticCategories.Accessories.ScarvesBandanas") },
      { name: "Sunglasses", label: i18n.t("StaticCategories.Accessories.Sunglasses") },
    ]
  },

  {
    value: "Footwear",
    label: i18n.t("StaticCategories.Footwear"),
    icon: <img src={iconFootwear} alt="Category" />,
    subcategories: [
      { name: "Boots", label: i18n.t("StaticCategories.Footwear.Boots") },
      { name: "Flats", label: i18n.t("StaticCategories.Footwear.Flats") },
      { name: "Heels", label: i18n.t("StaticCategories.Footwear.Heels") },
      { name: "Mens", label: i18n.t("StaticCategories.Footwear.Mens") },
      { name: "Sandals", label: i18n.t("StaticCategories.Footwear.Sandals") },
      { name: "Slippers", label: i18n.t("StaticCategories.Footwear.Slippers") },
      { name: "Sneakers & Runners", label: i18n.t("StaticCategories.Footwear.SneakersRunners") },
    ]
  },
  {
    value: "Men's Clothing",
    label: i18n.t("StaticCategories.MensClothing"),
    icon: <img src={iconMenClothing} alt="Category" />,
    subcategories: [
      { name: "Activewear", label: i18n.t("StaticCategories.MensClothing.Activewear") },
      { name: "Dress Shirts", label: i18n.t("StaticCategories.MensClothing.DressShirts") },
      { name: "Jackets & Coats", label: i18n.t("StaticCategories.MensClothing.JacketsCoats") },
      { name: "Pants", label: i18n.t("StaticCategories.MensClothing.Pants") },
      { name: "Shorts", label: i18n.t("StaticCategories.MensClothing.Shorts") },
      { name: "Socks", label: i18n.t("StaticCategories.MensClothing.Socks") },
      { name: "Sweaters & Hoodies", label: i18n.t("StaticCategories.MensClothing.SweatersHoodies") },
      { name: "Swimwear", label: i18n.t("StaticCategories.MensClothing.Swimwear") },
      { name: "Tank Tops", label: i18n.t("StaticCategories.MensClothing.TankTops") },
      { name: "T-shirts", label: i18n.t("StaticCategories.MensClothing.Tshirts") },
      { name: "Underwear", label: i18n.t("StaticCategories.MensClothing.Underwear") },
    ]
  },
  {
    value: "Gifts",
    label: i18n.t("StaticCategories.Gifts"),
    icon: <img src={iconGift} alt="Category" />,
    subcategories: [
      { name: "Adults", label: i18n.t("StaticCategories.Gifts.Adults") },
      { name: "Funny", label: i18n.t("StaticCategories.Gifts.Funny") },
      { name: "Mugs", label: i18n.t("StaticCategories.Gifts.Mugs") },
      { name: "Novelty", label: i18n.t("StaticCategories.Gifts.Novelty") },
      { name: "Personalized", label: i18n.t("StaticCategories.Gifts.Personalized") },
      { name: "Religious", label: i18n.t("StaticCategories.Gifts.Religious") },
    ]
  },

  {
    value: "Sports & Outdoors",
    label: i18n.t("StaticCategories.SportsOutdoors"),
    icon: <img src={iconSportOutdoor} alt="Category" />,
    subcategories: [
      { name: "Activewear", label: i18n.t("StaticCategories.SportsOutdoors.Activewear") },
      { name: "Biking", label: i18n.t("StaticCategories.SportsOutdoors.Biking") },
      { name: "Camping", label: i18n.t("StaticCategories.SportsOutdoors.Camping") },
      { name: "Equipment & Accessories", label: i18n.t("StaticCategories.SportsOutdoors.EquipmentAccessories") },
      { name: "Fishing", label: i18n.t("StaticCategories.SportsOutdoors.Fishing") },
    ]
  },

  {
    value: "Automotive",
    label: i18n.t("StaticCategories.Automotive"),
    icon: <img src={iconAutomotive} alt="Category" />
  },
  {
    value: "Bags & Wallets",
    label: i18n.t("StaticCategories.BagsWallets"),
    icon: <img src={iconBagWallet} alt="Category" />
  },
  {
    value: "Seasonal",
    label: i18n.t("StaticCategories.Seasonal"),
    icon: <img src={iconSeasonal} alt="Category" />,
    subcategories: [
      { name: "Christmas", label: i18n.t("StaticCategories.Seasonal.Christmas") },
      { name: "Father's Day", label: i18n.t("StaticCategories.Seasonal.FathersDay") },
      { name: "Halloween", label: i18n.t("StaticCategories.Seasonal.Halloween") },
      { name: "Mother's Day", label: i18n.t("StaticCategories.Seasonal.MothersDay") },
    ]
  },
  {
    value: "Festivals & Parties",
    label: i18n.t("StaticCategories.FestivalsParties"),
    icon: <img src={iconFestivalsParties} alt="Category" />,
    subcategories: [
      { name: "Party Supplies", label: i18n.t("StaticCategories.FestivalsParties.PartySupplies") },
      { name: "Wedding", label: i18n.t("StaticCategories.FestivalsParties.Wedding") }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/staticCategories.js